import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import { usePortalAuthContext } from '../../contexts/portalAuth';
import { PORTAL_SECTIONS } from './portalSections';

/**
 * The portal's landing route. Which sections exist is up to the tenant, so
 * rather than defaulting to a fixed screen it forwards to the first one that
 * is actually switched on.
 */
export const PortalHome = () => {
  const { t } = useTranslation();
  const { hasModule } = usePortalAuthContext();

  const firstAvailable = PORTAL_SECTIONS.find((section) => hasModule(section.module));

  if (!firstAvailable) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('Your service provider has not enabled any sections yet.')}
      </Typography>
    );
  }

  return <Navigate to={firstAvailable.path} replace />;
};
